import React, { FC, useState } from 'react';
import {
  makeStyles,
  Grid,
  FormControlLabel,
  Checkbox,
  Typography,
  TextField
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  tipGuide: {
    width: '25%'
  },
  footNotesTitle: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2)
  },
  container: {
    margin: 'auto',
    maxWidth: 320,
    alignItems: 'center'
  },
  contactlessDelivery: {
    marginTop: 12
  },
  customNote: {
    marginTop: 18
  },
  helperText: { textAlign: 'end' }
}));

interface FootNotesProps {
  value?: boolean;
  onChange?: (value: boolean) => void;
  contactlessDelivery?: boolean;
  showContactLess?: boolean;
  onChangeContactlessDelivery?: (value: boolean) => void;
  customNote?: string;
  showCustomNote?: boolean;
  onChangeCustomNote?: (value: string) => void;
}

const FootNotes: FC<FootNotesProps> = ({
  value,
  onChange,
  contactlessDelivery,
  showContactLess,
  onChangeContactlessDelivery,
  customNote,
  showCustomNote,
  onChangeCustomNote
}) => {
  const classes = useStyles();
  const [state, setState] = useState({
    noPlasticUtensils: value ?? true,
    contactlessDelivery: contactlessDelivery ?? false,
    customNote: customNote ?? ''
  });

  const setNoUseUtensils = (checked: boolean) => {
    setState({ ...state, noPlasticUtensils: checked });
    if (onChange) {
      onChange(checked);
    }
  };

  const setContactlessDelivery = (checked: boolean) => {
    setState({ ...state, contactlessDelivery: checked });
    if (onChangeContactlessDelivery) {
      onChangeContactlessDelivery(checked);
    }
  };

  const setCustomNote = (note: string) => {
    setState({ ...state, customNote: note });
    if (onChangeCustomNote) {
      onChangeCustomNote(note);
    }
  };

  return (
    <Grid container direction="column" className={classes.container}>
      <FormControlLabel
        control={
          <Checkbox
            checked={state.noPlasticUtensils}
            onChange={(_: any, v: boolean) => setNoUseUtensils(v)}
            name="checkedB"
            color="primary"
          />
        }
        label="No Plastic Utensils"
      />
      <Typography color="textSecondary">
        Thank you for saving the planet.
      </Typography>
      <Typography color="textSecondary">
        Reducing plastic waste is the way to go.
      </Typography>
      {showContactLess && (
        <FormControlLabel
          className={classes.contactlessDelivery}
          control={
            <Checkbox
              checked={state.contactlessDelivery}
              onChange={(_: any, v: boolean) => setContactlessDelivery(v)}
              name="contactlessDelivery"
              color="primary"
            />
          }
          label="I want contactless delivery (drop off at front porch, ring the bell and leave)"
        />
      )}
      {showCustomNote && (
        <TextField
          className={classes.customNote}
          id="customNote"
          name="customNote"
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          helperText={`${state.customNote.length}/100`}
          FormHelperTextProps={{ className: classes.helperText }}
          value={state.customNote || ''}
          inputProps={{
            maxLength: 100
          }}
          label="Custom Note/Delivery Instruction"
          onChange={e => setCustomNote(e.target.value)}
        />
      )}
    </Grid>
  );
};

export default FootNotes;
